export const NET_BUY_SELL_DEFAULT_PRESET = '90';

export const NET_BUY_SELL_WINDOWS = [
  { label: 'Last 30 Days', caption: 'last 30 days', value: '30' },
  { label: 'Last 90 Days', caption: 'last 90 days', value: '90' },
  { label: 'Year to Date', caption: 'year to date', value: 'ytd' },
] as const;
